import { createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../../../redux/slice";
import * as api from "../api";

export const doGetAllUsers = createAsyncThunk("users/getAllUsers", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getAllUsers(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateUser = createAsyncThunk("users/doCreateUser", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateUser(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateUser = createAsyncThunk("users/doUpdateUser", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateUser(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteUser = createAsyncThunk("users/doDeleteUser", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteUser(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
